import { render, staticRenderFns } from "./BankCard.vue?vue&type=template&id=2831923c&scoped=true&"
import script from "./BankCard.vue?vue&type=script&lang=js&"
export * from "./BankCard.vue?vue&type=script&lang=js&"
import style0 from "./BankCard.vue?vue&type=style&index=0&id=2831923c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831923c",
  null
  
)

export default component.exports